module.exports = __webpack_public_path__ + "static/media/producto3.90a65a67.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/producto3.png
// module id = 253
// module chunks = 0